import React, { useEffect, useState } from "react";
import "./PaymentDonePage.css";
import verifiedLogo from "./image/verified-logo.png";
import foodImg from "./image/food-img.png";

import { RiArrowDropDownLine } from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { IoMdStopwatch } from "react-icons/io";
import { TbUsers } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { GiSandsOfTime } from "react-icons/gi";
import { FaRegClock } from "react-icons/fa6";

import { Link, useParams } from "react-router-dom";
import { GoInfo } from "react-icons/go";
import axios from "axios";
import { API_BASE_URL } from "../utils";
import BlueCardInfoCard from "../My--Bidding--design/comp/BlueCardInfoCard";
import VenueInfoComp from "../My--Bidding--design/comp/VenueInfoComp";
import NoEvent from '../My--Bidding--design/image/no-event.svg'



const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function PaymentDonePage() {

    const { id } = useParams();

    const [data, setData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    const handleGetPaymentInfo = async (longitude, latitude) => {
        try {
            const formData = new FormData();
            formData.append("order_id", id);
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/getThankYouDetails`,
                formData,
            );


            console.log("response", response.data);
            if (response.data?.status) {
                setData(response.data.data);
            } else {
                console.warn("No valid data received:", response.data);
            }
        } catch (error) {
            console.error("Error fetching payment info:", error);
        }
    };


    useEffect(() => {
        // Get user location and fetch events
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());
                    handleGetPaymentInfo(latitude, longitude);
                },
                (error) => {
                    // alert("Please enable Geo Location Service to find events in your locality.");
                    console.error('Error in finding location: ', error);
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, []);


    return (
        <>
            <div className="payment-done-container">
                <div className="payment-card-d">

                    <div className="success-container-d-payment">
                        <div className="success-icon-d"><img src={verifiedLogo} alt="" /></div>
                        <h2 className="success-text-d">Payment Successful!</h2>
                    </div>

                    <div className="booking-status-container-d">

                        <div className="status-container-d-tag-prom">
                            <div className="scdtp-icon-wrap">
                                <div className="scdtp-icon">
                                    <FaRegClock />
                                </div>
                                <div className="scdtp-text-wrap">
                                    <h6>Waiting for Booking Confirmation</h6>
                                    <p>
                                        We've notified <a href="#">{data?.club_name}</a> about your booking. You'll receive a confirmation once the restaurant accepts your request.
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className="summary-section-d">
                            <div className="summary-header-d">
                                <span className="summary-title-d">View Party Summary</span>
                            </div>
                            <div className="summary-body-d">
                                {/* <img
                                    src={url + data?.package_img}
                                    alt="Party"
                                   
                                /> */}
                                <div className="summary-event-d">
                                    {data?.events && data.events.length ? (
                                        <>
                                            <Link to={`/event/${data?.events[0]?.slug1}/${data?.events[0]?.slug2}`}>
                                                <img src={url + data?.events[0].image} className="summary-image-d" alt={`venue ${1}`} />
                                                <div className="pmu-event-info">
                                                    <h6>{data?.events[0].name}</h6>
                                                    <span>Time:{" "}{data?.events[0].event_time}-{data?.events[0].event_end_time}</span>
                                                </div>
                                            </Link>
                                        </>
                                    ) : (
                                        <>

                                            <img src={NoEvent} alt={`venue ${1}`} className="summary-image-d" />

                                        </>
                                    )}
                                </div>
                                <div className="summary-details-d">

                                    <BlueCardInfoCard orderData={data} />
                                    <div className="summary-info-club-d">
                                        <VenueInfoComp orderData={data} />
                                    </div>
                                    <div className="badge-group-d-amount">
                                        <div className="badge-amount-d">
                                            <span>Amount Paid
                                            </span>
                                            <span>
                                                ₹{data?.net_payable_amount}
                                            </span>
                                        </div>

                                        <div className="badge-amount-d">
                                            <span >Amount Paid
                                            </span>
                                            <span>
                                                ₹{data?.net_payable_amount}
                                            </span>
                                        </div>

                                        <div className="badge-amount-d paid-bad">
                                            <span>
                                                Amount Paid
                                            </span>
                                            <span>
                                                ₹{data?.net_payable_amount}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="note-d">
                        <span>
                            <GoInfo />{" "} <strong>Note</strong>
                        </span>
                        <p>
                            Your booking will only be confirmed once the
                            restaurant accepts. You won’t be charged further until the full confirmation.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
